<template>
  <div class="add-dialog">
    <el-dialog title="师生互动新增" :visible.sync="interactionAddDialogShow" :close-on-click-modal="false" width="1000px"
      :before-close="dialogClose" @open="dialogOpen">
      <!-- 学年学期 -->
      <el-form :model="formData" :rules="rules" ref="formRef" label-width="100px" class="ruleForm"
        label-position="right" :inline="true">
        <el-form-item label="选择学年:" label-width="100px" prop="schoolYear">
          <year-range-picker style="width: 250px;" v-model="formData.studentInfo.schoolYear" />
        </el-form-item>
        <el-form-item label="选择学期:" label-width="100px" prop="semester">
          <el-select v-model="formData.studentInfo.semester" placeholder="请选择学期" style="width: 235px">
            <el-option v-for="item in semesterOptions" :key="item.dictValue" :label="item.dictLabel"
              :value="item.dictValue">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="record-form-container">
        <!-- <h3>学生基本信息</h3> -->
        <!-- <el-button size="small" type="success" @click="submitForm"
          style="position: absolute; top: 10px; right: 10px;">保存</el-button> -->
        <el-form ref="formRef" :model="formData" label-width="120px" :rules="rules" label-position="top">

          <!-- 学生信息
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="学生姓名" prop="studentInfo.studentName">
                <el-input v-model="formData.studentInfo.studentName" placeholder="请输入学生姓名" />
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="性别" prop="studentInfo.sex">
                <el-input v-model="formData.studentInfo.sex" placeholder="请输入性别" />
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="年龄" prop="studentInfo.age">
                <el-input v-model="formData.studentInfo.age" placeholder="请输入年龄" />
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="所在班级" prop="studentInfo.className">
                <el-input v-model="formData.studentInfo.className" disabled placeholder="请输入所在班级" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="家长姓名" prop="studentInfo.patriarchName">
                <el-input v-model="formData.studentInfo.patriarchName" placeholder="请输入家长姓名" />
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="与学生关系" prop="studentInfo.relationship">
                <el-input v-model="formData.studentInfo.relationship" placeholder="请输入与学生关系" />
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="联系电话" prop="studentInfo.patriarchPhone">
                <el-input v-model="formData.studentInfo.patriarchPhone" placeholder="请输入联系电话" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item label="学生总体情况" prop="studentInfo.overview">
            <el-input type="textarea" v-model="formData.studentInfo.overview" :rows="4" show-word-limit maxlength="1000"
              placeholder="请输入学生总体情况" />
          </el-form-item> -->

          <!-- 谈话记录 -->
          <h3>谈话备忘记录</h3>
          <el-button type="primary" @click="addRecord">+ 添加记录</el-button>

          <div v-for="(record, index) in formData.records" :key="index"
            style="margin-top: 20px; border: 1px solid #0066cc; padding: 15px; border-radius: 4px; position: relative;">
            <h4>谈话备忘记录 {{ index + 1 }}</h4>
            <div style="position: absolute; top: 10px; right: 10px">
              <el-button size="mini" type="danger" @click="removeRecord(index)">删除</el-button>
              <el-button size="mini" type="success" style="margin-right: 10px;"
                @click="submitSingleRecord(record, index)">保存</el-button>
            </div>

            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="谈话时间" :prop="'records.' + index + '.interactTime'"
                  :rules="[{ required: true, message: '请选择谈话时间', trigger: 'change' }]">
                  <el-date-picker v-model="record.interactTime" type="date" value-format="yyyy-MM-dd"
                    placeholder="请选择日期" style="width: 100%" />
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item label="地点" :prop="'records.' + index + '.interactLocation'"
                  :rules="[{ required: true, message: '请输入谈话地点', trigger: 'blur' }]">
                  <el-input v-model="record.interactLocation" placeholder="请输入地点" />
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item label="谈话内容" :prop="'records.' + index + '.interactContent'"
              :rules="[{ required: true, message: '请输入谈话内容', trigger: 'blur' }]">
              <el-input type="textarea" v-model="record.interactContent" :rows="4" placeholder="请输入谈话内容" />
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="btn-list">
        <el-button type="primary" @click="finish">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";

import { baseURL } from "@/api/request"; // 服务器地址
export default {
  props: [
    'interactionAddDialogShow',
    'semesterOptions',
    'studentId',
    'studentName',
    'studentInfo',
    'teacherId',
    'teacherName',
    'studentDetailInfo',
    'talkStudentInfo',
  ],
  data() {
    return {
      // studentInfo: {
      //   name: '',
      //   gender: '',
      //   age: '',
      //   class: '',
      //   parentName: '',
      //   relationship: '',
      //   phone: '',
      //   overallSituation: ''
      // },
      newRecordType: 'conversation',
      nextId: 3,
      maxlength: 1000,
      action: "", // 文件上传路径
      // ruleForm: {
      //   schoolYear: "",
      //   semester: "",
      //   interactionTime: "",
      //   interactionContent: "",
      //   interactionResult: ""
      // },
      // rules: {
      //   interactionContent: [{ required: true, message: "请输入互动内容", trigger: "blur" }],
      //   interactionResult: [{ required: true, message: "请输入互动结果", trigger: "blur" }],
      //   schoolYear: [{ required: true, message: "请选择学年", trigger: "change" }],
      //   semester: [{ required: true, message: "请选择学期", trigger: "change" }],
      //   interactionTime: [{ required: true, message: "请选择时间", trigger: "change" }],
      // },
      formData: {
        studentInfo: {
          // 学生基本信息（可选，如果后端返回）
          studentName: '',
          sex: '',
          age: '',
          gradeClassName: '', // 注意：模板里用的是 gradeClassName，不是 className
          patriarchName: '',
          relationship: '',
          patriarchPhone: '',
          overview: '',
        },
        records: [
        ],
      },
      rules: {
        'studentInfo.interactTime': [
          { required: true, message: '请选择谈话时间', trigger: 'change' } // 注意：日期选择器用 change 触发更合适
        ],
        'studentInfo.interactLocation': [
          { required: true, message: '请输入谈话地点', trigger: 'blur' }
        ],
        'studentInfo.interactContent': [
          { required: true, message: '请输入谈话内容', trigger: 'blur' }
        ],
        'studentInfo.studentName': [
          { required: true, message: '请输入学生姓名', trigger: 'blur' }
        ],
        'studentInfo.sex': [
          { required: true, message: '请输入性别', trigger: 'blur' }
        ],
        'studentInfo.age': [
          { required: true, message: '请输入年龄', trigger: 'blur' }
        ],
        'studentInfo.className': [
          { required: true, message: '请输入所在班级', trigger: 'blur' }
        ],
        'studentInfo.patriarchName': [
          { required: true, message: '请输入家长姓名', trigger: 'blur' }
        ],
        'studentInfo.relationship': [
          { required: true, message: '请输入与学生关系', trigger: 'blur' }
        ],
        'studentInfo.patriarchPhone': [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '手机号格式错误', trigger: 'blur' }
        ],
        'studentInfo.overview': [
          { required: true, message: '请输入学生总体情况', trigger: 'blur' }
        ]
      },
      talkRecordMainId: null, // 学生基本信息ID 
    };
  },
  created() {
    // this.action = `${baseURL}${this.$url.insertTeacherStudentInteract}`;
  },
  methods: {
    // addRecord() {
    //   const newRecord = {
    //     id: this.nextId++,
    //     type: this.newRecordType,
    //     year: '',
    //     month: '',
    //     day: '',
    //     weekday: '',
    //     location: '',
    //     content: ''
    //   };
    //   this.records.push(newRecord);
    // },

    // removeRecord(index) {
    //   if (this.records.length > 1) {
    //     this.records.splice(index, 1);
    //   }
    // },

    // saveForm() {
    //   const formData = {
    //     studentInfo: this.studentInfo,
    //     records: this.records
    //   };
    //   console.log('表单数据:', formData);
    //   // 这里可以添加保存逻辑
    // },
    // 开启弹窗
    dialogOpen() {
      // console.log(this.detailData);
      this.talkRecordMainId = this.talkStudentInfo ? this.talkStudentInfo.id : null;

      this.formData = {
        studentInfo: {
          // ...this.formData.studentInfo,
          schoolYear: this.school.schoolYear,
          semester: this.school.semester,
          studentName: this.studentName,
          // sex: this.studentDetailInfo.sex,
          // age: this.talkStudentInfo.age,
          className: this.studentDetailInfo.gradeName + this.studentDetailInfo.className,
          // patriarchName: '',
          // relationship: '',
          // patriarchPhone: '',
          // overview: this.talkStudentInfo.overview,
        },
        records: []
      };
    },
    // 关闭弹出窗口
    dialogClose() {
      this.$emit("update:interactionAddDialogShow", false);
      this.$refs["formRef"].clearValidate(); //移除表单检验结果
    },
    // 添加一条记录
    addRecord() {
      // console.log(this.tableData, this.formData.studentInfo);

      // if (!this.talkRecordMainId) { this.$message.warning('请先保存学生基本信息'); return };
      // if (this.formData.studentInfo.patriarchName == '' || this.formData.studentInfo.relationship == '' || this.formData.studentInfo.patriarchPhone == '') { this.$message.warning('请先保存学生基本信息'); return };
      this.$refs.formRef.validate(valid => {
        if (valid) {
          // if (this.formData.records.length == 0) {
          //   this.submitForm();
          // };
          this.formData.records.push({
            // id: Date.now(),
            interactTime: '',
            interactLocation: '',
            interactContent: ''
          });
        }
      });
    },

    // 删除一条记录
    removeRecord(index) {
      this.$confirm('确定要删除这条记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.formData.records.splice(index, 1);
      })
    },

    submitSingleRecord(row, index) {
      // console.log(row);
      this.$refs.formRef.validate(valid => {
        if (valid) {
          // 提交逻辑
          let url;

          let data = {
            "schoolId": this.school.id,
            "schoolName": this.school.schoolName,
            "gradeId": this.studentInfo.gradeId,
            "gradeName": this.studentInfo.gradeName,
            "classId": this.studentInfo.classId,
            "className": this.studentInfo.className,
            "studentId": this.studentId,
            "studentName": this.formData.studentInfo.studentName,
            "schoolYear": this.formData.studentInfo.schoolYear,
            "semester": this.formData.studentInfo.semester,
            "teacherId": this.teacherId,
            "teacherName": this.teacherName,
            "interactTime": row.interactTime,
            "interactContent": row.interactContent,
            "interactLocation": row.interactLocation
          };

          let config = {
            headers: {
              bbfAdminTeacherToken: window.localStorage.getItem("bbfAdminTeacherToken"),
              "Content-Type": "multipart/form-data",
            },
          };

          if (row.id) {
            data.id = row.id;
            url = this.action = `${baseURL}${this.$url.editTeacherStudentInteract}`;
          } else {
            url = this.action = `${baseURL}${this.$url.insertTeacherStudentInteract}`;
          };

          // 创建 FormData 并填充数据
          let formData = new FormData();
          Object.entries(data).forEach(([key, value]) => {
            if (value !== null && value !== undefined) {
              formData.append(key, value);
            }
          });

          // 调用接口
          axios
            .post(this.action, formData, config)
            .then((res) => {
              this.count = 1;
              // res.data 服务器返回的数据
              let data = res.data;
              // console.log(res);
              if (data.code == 200) {
                this.$message.success(data.msg);
                this.formData.records[index].id = data.data;
                return;
              } else if (data.code == 401 || data.code == 403) {
                // token失效
                this.$message.error("获取用户信息失败，请重新登录");
                this.$store.dispatch("user/resetToken");
                this.$router.replace({
                  path: "login",
                  query: { redirect: this.$router.currentRoute.fullPath },
                });
              } else {
                this.$message.error(data.msg);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });


      // let data = {
      //   "talkrecordMain": {
      //     ...this.formData.studentInfo,
      //     "schoolId": this.school.id,
      //     "schoolName": this.school.schoolName,
      //     "gradeId": this.studentInfo.gradeId,
      //     "gradeName": this.studentInfo.gradeName,
      //     "classId": this.studentInfo.classId,
      //     "className": this.studentInfo.className,
      //     "studentId": this.studentId,
      //   },
      //   "talkrecordDetails": {
      //     ...row,
      //     "teacherId": this.teacherId,
      //     "teacherName": this.teacherName,
      //   }
      // };
      // if (row.id) {
      //   this.put(this.$url.editTeacherStudentInteract, data).then(res => {
      //     if (res.code == 200) {
      //       this.$message.success(res.msg);
      //       // this.$emit("refresh");
      //     } else {
      //       this.$message.error(res.msg);
      //     }
      //   })
      // } else {
      //   this.post(this.$url.insertTeacherStudentInteract, data).then(res => {
      //     if (res.code == 200) {
      //       this.$message.success(res.msg);
      //       this.formData.records[index].id = res.data;
      //       // this.$emit("refresh");
      //     } else {
      //       this.$message.error(res.msg);
      //     }
      //   })
      // }
    },

    // 提交表单
    submitForm() {
      this.$refs.formRef.validate(valid => {
        if (valid) {
          let data = {
            ...this.formData.studentInfo,
            "schoolId": this.school.id,
            "schoolName": this.school.schoolName,
            "gradeId": this.studentInfo.gradeId,
            "gradeName": this.studentInfo.gradeName,
            "classId": this.studentInfo.classId,
            "className": this.studentInfo.className,
            "studentId": this.studentId,
          };
          this.post(this.$url.insertTalkStudentInfo, data).then(res => {
            if (res.code == 200) {
              // 上传成功，刷新列表
              // this.$message.success(res.msg);
              this.talkRecordMainId = res.data;
              // this.$emit("refresh");
              // this.dialogClose();
              return;
            } else {
              this.$message.error(res.msg);
            }
          })
          // if (this.talkRecordMainId) {
          //   data.id = this.talkRecordMainId;
          //   // console.log('提交数据:', data);
          //   // 这里可以调用接口发送请求
          //   this.put(this.$url.editTalkStudentInfo, data).then(res => {
          //     if (res.code == 200) {
          //       // 上传成功，刷新列表，关闭dialog
          //       this.$message.success(res.msg);
          //       // this.$emit("refresh");
          //       // this.dialogClose();
          //       return;
          //     } else {
          //       this.$message.error(res.msg);
          //     }
          //   })
          // } else {
          //   // 新增时不传 id，删除 data.id（如果之前有设置）
          //   if (data.id) {
          //     delete data.id;
          //   };
          //   this.post(this.$url.insertTalkStudentInfo, data).then(res => {
          //     if (res.code == 200) {
          //       // 上传成功，刷新列表，关闭dialog
          //       this.$message.success(res.msg);
          //       this.talkRecordMainId = res.data;
          //       // this.$emit("refresh");
          //       // this.dialogClose();
          //       return;
          //     } else {
          //       this.$message.error(res.msg);
          //     }
          //   })
          // }

        } else {
          this.$message.error('请填写完整并检查表单');
          return false;
        }
      });
    },

    // 点击完成
    finish() {
      if (this.formData.records.length == 0) {
        this.$message.error('请添加至少一条记录');
        return;
      }
      this.$emit("refresh");
      this.dialogClose();
    },

    // 重置表单
    resetForm() {
      this.$refs.formRef.resetFields();
      this.formData.records = [];
    }
  },
};
</script>

<style lang="scss" scoped>
@import "./interactionAddDialog.scss";
</style>